"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageSystemSettings = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsSystemSettingsTabber = require("../../components/DmsSystemSettingsTabber/DmsSystemSettingsTabber");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * PlxPageSystemSettings renders the system settings page with a tab-based interface.
 * It defines default values for system settings tabs.
 */

const DmsPageSystemSettings = _ref => {
  let {
    logs = true,
    login = true,
    uploadFile = true,
    remoteAuth = true,
    ldap = true,
    routeList = true,
    system = true
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "System Settings"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("SystemSettings").d("System Settings"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsSystemSettingsTabber.DmsSystemSettingsTabber, {
    logs: logs,
    login: login,
    uploadFile: uploadFile,
    remoteAuth: remoteAuth,
    ldap: ldap,
    routeList: routeList,
    system: system
  }))));
};
exports.DmsPageSystemSettings = DmsPageSystemSettings;